<bb-react [entity]="entity"></bb-react>
